import * as React from 'react';
import {useEffect, useState} from 'react';
import axios from "axios";
import "../Styles/ImageItem.css";
import { Clock, Wifi } from "react-feather";
import ReactPlayer from "react-player";
import { AskModal } from '../AskModal';
import { useHistory } from 'react-router-dom';
import ShowActions from './ShowActions';


export const OcationContentItem = ({passPortal, postBalance, user}) => {
    const [loadItem, setLoadItem] = useState(false);
    const [counter, setCounter] = useState(8);
    const [type, setType] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showActions, setShowActions] = useState(false);
    const [message, setMessage] = useState("");
    let interval = null;
    const {location, replace, goBack} = useHistory();
    const { campaign, search, DeviceID, ap, avisos }: any = location.state ;
    const [actions, setActions] = useState([]);

    useEffect(() => {
        fetchActionsLead();
        return () => {
            if(interval) {
                clearInterval(interval);
            }
        }
    }, []);
    const fetchActionsLead = () => {
      if(campaign) {
        const a = campaign.lead_actions ? campaign.lead_actions.split(",") : [];
        setActions(a);
      }
    }

    const _renderItem = () => {

      if(campaign.CampaignVideoURL) {
        let url = campaign.CampaignVideoURL;
        url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
          return (
            <ReactPlayer
              width="100%"
              onEnded={_endVideo}
              style={{
                  objectFit: "contain",
                  maxHeight: "100%"
              }}
              url={url}
              light={true}
              playing={true}
              playsinline={true}
            />
          )
        } else {
          initCounter();
          return (
              <img
              onLoad={e => setLoadItem(true)}
              className={loadItem ? "mw-100": "w-100"}
              style={{
                objectFit: "contain",
                maxHeight: "100%"
              }}
              src={`/google-storage/${encodeURIComponent(
                campaign.CampaignImageURL,
              )}`}
            />
          );
        }
    
    }

    const _endVideo = () => {
       setType("video");
       setShowActions(true);
    }
    
    const _postImpression = async (isOk) => {
        try {
          const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID: user.device_id,
            CampaignID: campaign.CampaignID,
            MediaType: type
          };
          await axios.post("/impressions", { fields });
          await postBalance(campaign, type);
          if(isOk) {
            passPortal(ap, campaign, DeviceID);
          }
          
        } catch (err) {
          console.log(err);
        }
    }

    const _goBack = () => {
      _postImpression(false);   
     /*  replace(`/avisos`, {
        device_id: DeviceID,
        avisos
      }) */
      if(search) {
        replace(`/${search}`);
      }else {
        goBack();
      }
    }

    const initCounter = () => {
        interval = setInterval(() => {
            if (counter === 0) {
                clearInterval(interval);
                setType("image");
                setShowActions(true);
                return;
            } else {
              setCounter(counter - 1);
            }
        }, 1000);
    }

    const captureLead = (action: string) => {
      //setShowModal(true);
      switch (action) {
        case "mail":
          postLead("email", user.email);
          break;
        case "sms":
          postLead("sms",  user.celular);
          break;
        case "wp":
          postLead("whatsapp", user.celular);
          break;
        default:
          break;
      }
    }

    const postLead = async(key, value) => {
      try {
        let fields = {
          advertiser_id: campaign.AdvertiserID,
          campaign_id: campaign.CampaignID,
          device_id: DeviceID.replace(/:/g, ''),
          [key]: value
        };
        await axios.post("/lead", {
          fields
        });
        setMessage("Muchas gracias!!");
        setShowModal(true);

      } catch (error) {
        console.log(error);
        setMessage("Ups ocurrio un error, intentalo mas tarde");

      }
    }

    return (
        <div className="ImageItemWrapper">
            {showModal && <AskModal ok={() => _postImpression(true)} cancel={_goBack}/>}
        <div className="ImageItemContainer">
          <div className="ImageItemText">
            <div style={{ display: "contents" }}>
              <Wifi size={32} />
              <span style={{ marginRight: "8px", marginLeft: "8px" }}>
                {" "}
                WiFi gratuito:
              </span>
            </div>
           {/*  { !campaign.CampaignVideoURL && <strong>{counter}</strong> } */}
           {/*  { (campaign.CampaignImageURL || surveyAnsw ) && <strong>{counter}</strong> } */}
          </div>
          <div className="Content">
            <div className="ImageItem">
              {_renderItem()}
            </div>
          </div>
          <div className="ImageItemText align-items-center">
            <Clock size={32} />
            <span style={{ marginRight: "8px", marginLeft: "8px" }}>
              20 min.
            </span>
          </div>
        {/*   {surveyAnsw && <span className="text-white" style={{ marginRight: "8px", marginLeft: "8px" }}>Haz Click en la imagen para descargar el cupón</span>} */}
          {
            showActions && actions.length &&  <ShowActions actions={actions} actionLead={(v) => captureLead(v)} message={message}/>
          }
        </div>
      </div>
    )
}

